<script>
  import Login from "./Login.svelte";
  import GenAdminPage from "./admin/GenAdminPage.svelte";
  import TeacherPage from "./teacher/TeacherPage.svelte";
  import UserPage from "./UserPage.svelte";
  import { user } from "./userStore.js";


  // export let menu = 2; 
  // export let prod = false; // 0 – dev mode
  // export let prod = true; // 1 – prod mode (User Only)

  // $: if (firebase.auth().currentUser && firebase.auth().currentUser.email == "gressus@yandex.ru") menu = 3; else menu = 1;
  
  // $: if ($user.admin) {
  //   menu = 4; 
  //   console.log('menu: ' + menu);
  // } else {
  //   if ($user.teacher) {
  //     menu = 3; 
  //   } else {
  //     menu = 1;
  //   }
  //   console.log('menu: ' + menu);
  // }

  // console.trace();

  window.onerror = function(error, url, line, column, errorObj) {
    let errorString = 'Uncaught ERROR: ' + error + ' url: ' + url + ' line: ' + line
      + ' Column: ' + column + ' StackTrace: ' +  errorObj;
    console.log(errorString);
    user.logErrorToDB(errorString, errorObj);
    // console.log(error.stack);
  };
  window.addEventListener("unhandledrejection", function(promiseRejectionEvent) { 
    console.log('unhandledrejection: ' + promiseRejectionEvent.reason)
    user.logErrorToDB(promiseRejectionEvent.reason.message, promiseRejectionEvent.reason.stack);
    // console.log('unhandledrejection: ' + JSON.stringify(promiseRejectionEvent))
    // console.log('unhandledrejection: ' + JSON.stringify(promiseRejectionEvent.target))
    // console.log('unhandledrejection: ' + JSON.stringify(promiseRejectionEvent.composedPath())) // Uncaught TypeError: Converting circular structure to JSON
    // console.log('unhandledrejection: ' + promiseRejectionEvent.promise.fail)
    // promiseRejectionEvent.promise.catch(()=>console.log('aaa'));
  });
  // window.addEventListener("rejectionhandled", function(promiseRejectionEvent) { 
  //   // handle error here, for example log
  //   // console.log('rejectionhandled: ' + JSON.stringify(promiseRejectionEvent))
  //   console.log('rejectionhandled: ' + promiseRejectionEvent.reason)
    // console.log('rejectionhandled: ' + JSON.stringify(promiseRejectionEvent.promise.timeStamp))
  //   console.log('rejectionhandled: ' + promiseRejectionEvent.promise); // .stack
  // });  
// aa

  // Перенесено в user.store
  // let page;
  // let pageHash = window.location.hash.split('#')[1];
  // switch (pageHash) {
  //   case "admin":
  //     page = "admin";      
  //     break;      
  //   case "teacher":
  //     page = "teacher";      
  //     break;
  //   default: // User
  //     page = "student";
  //     let q = new URL(window.location.href).searchParams.get("q") || "none";
  //     break;
  // } 

  // let isTeacherPage = pageHash == "teacher";
  // if (isTeacherPage) {
  //   menu = 3;
  // } else {
  //   menu = 1;
  // }

  // $: if (isTeacherPage) {
  //   if ($user.teacher) menu = 3;
  //   else menu = 6;
  // }

</script>

<style>
  :global(body) {
    top: 0;
    margin: 0;
    padding: 0;
  }

  /* .hidden {
    display: none !important;
  } */
</style>

<!-- <h1> Task oriented <b>learning</b> </h1>  <b>Link</b> Education -->

<Login/>

{#if $user.page == "admin" && $user.loggedin && $user.admin}
  <GenAdminPage />
{/if}

{#if $user.page == "teacher" && $user.loggedin && $user.teacher}
  <TeacherPage />
{/if}

{#if $user.page == "student" && $user.loggedin}
  <UserPage />
{/if}

<!-- -{$user.loggedin}- -->
<!-- fixme bug with fadeIn/Out in UserPage -->
<!-- {#if $user.loggedin}
  <div class:hidden={!$user.loggedin}>
    {#if !prod}
      {#if menu === 1}
        <UserPage />
      {/if}
      {#if menu === 2}
        <AdminPage />
      {/if}
      {#if menu === 3}
        <TeacherPage />
      {/if}
      {#if menu === 4}
        <HeadTeacher />
      {/if}
      {#if menu === 6}
        <Loading />
      {/if}
    {:else}
      <UserPage/>
    {/if}
  </div>
{/if} -->